/* eslint-disable import/first */
import React, { useState, useEffect, useContext } from 'react';
import { Paper, Grid, Typography, DialogContent } from '@material-ui/core';
import Hreflang from '../../components/Hreflang';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate, useLocation } from '@reach/router';
import { useIntl, FormattedMessage } from 'react-intl';
const { selectDesktop } = Slices.appSlice;
const { sendFeedBack, getOrderDetail, getOrder } = Slices.orderSlice;
import DrawerPwa from '../../components/DrawerPwa';
import Skeleton from 'react-loading-skeleton';
import { Badge } from '../../components/Icons';
import FeedbackInfo from './FeedbackInfo';
import FeedbackForm from '../../components/FeedbackForm';
import OrderInfo from '../../components/OrderInfo';
import FeedbackHeader from './FeedbackIconArea';
// import TopBar from '../../components/TopBar';
// eslint:fix TopBar is defined but is never used
import DialogBox from '../../components/DialogBox';
import { Context } from '../../components/Multi-lang/Wrapper';
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import NoFeedback from './NoFeedback';
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
const { selectAllMain } = Slices.categorySlice;

import css from './index.module.scss';
import Loader from '../../components/Loader';
import NoOrder from '../../components/NoOrder';
import notLoggedInImg from './images/norating.svg';
import PopUpHeading from '../../components/PopUpHeading';
import FeedbackPopup from './FeedbackPopup';

export const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase().replace(/\s/g, '-'));
function Feedback() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const location = useLocation();
  const auth = useSelector((state) => state.auth);
  const [stateOpen, setStateOpen] = useState(false);
  const [loadState, setLoadState] = useState(false);
  const [skeltonLoad, setSkeltonLoad] = useState('intial');
  const [gradeIndex, setGradeIndex] = useState();
  const [smileIndex, setSmileIndex] = useState(-1);
  const order = useSelector((state) => state.order);
  const [hist, setHist] = React.useState([]);
  const [pageLoader, setPageLoader] = React.useState(false);
  const [dialogState, setDialogState] = useState(true);
  // const [orderInfo, setOrderInfo] = useState({});
  // eslint:fix orderinfo is defined but is never used
  const context = useContext(Context);
  const categories = useSelector(selectAllMain);
  const result = categories?.sort((a, b) => a.position - b.position);
  const exploreMenuPath = `/${context?.locale}/${URLEncode(result[0]?.name)}/${result[0]?.id}`;

  useEffect(() => {
    if (auth.isLoggedIn && !loadState) {
      const payload = {
        isActive: 0,
        page: 1,
      };
      if (order.detail.info.data && order.detail.info.data.list) {
        setHist(order.detail.info.data.list);
        setSkeltonLoad('loaded');
      }
      dispatch(getOrder(payload))
        .then((resp) => {
          setHist(resp.payload.data.data.list);
          setSkeltonLoad('loaded');
        })
        .catch((e) => {
          setSkeltonLoad('loaded');
          console.log(e);
        });
      setLoadState(true);
    } else {
      setSkeltonLoad('loaded');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isLoggedIn]);
  useEffect(() => {
    if (location.state && location.state.fromPage === 'trackOrder') {
      setSmileIndex(location.state.rating);
    }
  }, [location.state]);

  useEffect(() => {
    // if (location?.state?.orderId) {
    //   const op = hist.filter((each) => each._id === location?.state?.orderId);
    //   setHist(op);
    // }
  });

  const submitFeedback = (feedbackObj) => {
    setPageLoader(true);

    let payload = { ...feedbackObj, rating: feedbackObj.rating + 1 };
    if (feedbackObj.description === '' && feedbackObj.reason === '') {
      delete payload.description;
      delete payload.reason;
    }
    if (payload.rating === 0) {
      delete payload.rating;
    }

    payload.mdbOrderId = (location.state && location.state.orderId) || hist[0]._id;
    dispatch(getOrderDetail({ orderId: payload.mdbOrderId })).then((resp) => {
      const orderInfo = resp.payload.data.data;

      const fetchItem = orderInfo?.items?.map((val) => {
        return { finalPrice: val.finalPrice, name: val.name };
      });

      payload.orderDetail = {
        amount: orderInfo.amount,
        items: fetchItem,
        sdmOrderId: orderInfo.uOrderRef + '',
      };
      dispatch(sendFeedBack(payload)).then((resp) => {
        setPageLoader(false);
      });
      setStateOpen((pre) => true);
      // isDesktop
      //   ? navigate(`/${intl.locale}/feedback/sent`, {
      //       state: {
      //         oldLocation: location?.state?.oldLocation || location,
      //         smileRating: smileIndex || 0,
      //       },
      //     })
      //   : setStateOpen(true);
    });
  };

  const changeDrawerStatus = () => {
    setStateOpen(false);
    setGradeIndex();
    setSmileIndex(-1);
    navigate(`/${intl.locale}/home`);
  };

  const isDesktop = useSelector(selectDesktop);

  const handleClose = () => {
    setDialogState(false);
    navigate(`/${intl.locale}/home`);
  };
  const closeDrawer = () => {
    setGradeIndex();
    setSmileIndex(-1);
    setStateOpen(false);
  };

  const navigateToExplore = () => {
    navigate(exploreMenuPath);
  };
  const onExitMemoized = React.useCallback(
    (e) => {
      navigate(`/${intl.locale}/home`);
    },
    [intl.locale, navigate]
  );
  if (skeltonLoad === 'intial') {
    return (
      <div className={css.skeltonRoot}>
        <Skeleton count={1} className={css.SkeletonLoad} height={275} />
        <Skeleton count={1} className={css.SkeletonLoad} height={43} />
        <Skeleton count={1} className={css.SkeletonLoad} height={120} />
        <Skeleton count={1} className={css.SkeletonLoad} height={40} />
      </div>
    );
  }
  const renderTermsList = (list) => {
    return list.map((each, index) => {
      if (each._id === location?.state?.orderId) {
        return <OrderInfo orderObj={each} page="feedback" />;
      }
    });
  };

  const titleDesc = <FormattedMessage id="ratings_and_feedback" defaultMessage="Feedback" />;

  return (
    <Grid>
      <Hreflang page="feedback" />
      {!isDesktop && (
        <Header
          icon={<FaArrowLeft onClick={onExitMemoized} />}
          title={<FormattedMessage id="navigation_feedback" defaultMessage="Feedback" />}
          actionButtons={[<LanguageButton />]}
        />
      )}
      <div className={hist.length === 0 ? css.noOrdermain : css.main}>
        {isDesktop ? (
          <>
            <Grid className={css.desktop}>
              <div className={css.title}>
                <div className={css.titleDesc}>
                  <PopUpHeading heading={titleDesc} onClose={onExitMemoized} />
                  {hist.length === 0 && (
                    <div className={css.errorContainer}>
                      <div className={css.errorText}>
                        <FormattedMessage
                          id="feedback_noOrdersFound"
                          defaultMessage="Oops! 🤥 We can’t find any orders from this account 🙊"
                        />{' '}
                      </div>
                      <div className={css.errorSubtext}>
                        <FormattedMessage id="feedback_noOrder2" />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <DialogContent className={css.dialogContent} dividers={true}>
                {hist.length === 0 ? (
                  <NoOrder
                    callback={navigateToExplore}
                    heading={
                      <FormattedMessage
                        id="no_rating_place_order"
                        defaultMessage="Please place your first order now!"
                      />
                    }
                    subHeading=""
                    img={notLoggedInImg}
                    isFeedback={true}
                  />
                ) : (
                  <>
                    <Grid className={css.dialogContentBody}>
                      <Grid className={css.column1}>
                        <Paper className={css.paperOuterArea} square>
                          <FeedbackHeader
                            smileIndex={smileIndex}
                            onSmileyChosen={(index) => setSmileIndex(index)}
                            gradeIndex={gradeIndex}
                            onGradeIndexChosen={(index) => setGradeIndex(index)}
                          />
                        </Paper>
                        {hist.length > 0 && (
                          <>
                            <Grid className={css.header}>
                              <Typography className={css.typography}>
                                <FormattedMessage id="order_detail" defaultMessage="Order" />
                              </Typography>
                              {location.state.fromPage !== 'trackOrder' && (
                                <Typography
                                  className={css.changeTypography}
                                  onClick={() =>
                                    navigate(`/${intl.locale}/order-history`, {
                                      replace: true,
                                      state: {
                                        fromPage: 'feedback',
                                        orderId: location?.state?.orderId
                                          ? location?.state?.orderId
                                          : hist[0]._id,
                                        oldLocation: location?.state?.oldLocation || location,
                                      },
                                    })
                                  }
                                >
                                  <FormattedMessage id="feedback_change" defaultMessage="CHANGE" />
                                </Typography>
                              )}
                            </Grid>
                            <Paper className={css.paperOuterArea} square>
                              {/* eslint:fix map is replaced with forEach */}
                              {location?.state?.orderId && renderTermsList(hist)}
                              {!location?.state?.orderId && (
                                <OrderInfo orderObj={hist[0]} page="feedback" />
                              )}
                            </Paper>
                          </>
                        )}
                      </Grid>
                      <Grid className={css.column2}>
                        {/* <Grid className={css.header}>
                          <Typography className={css.typography}>
                            <FormattedMessage
                              id="submit_feedback"
                              defaultMessage="Submit Your Feedback"
                            />
                          </Typography>
                        </Grid> */}
                        <Paper className={css.feedbackBody} square>
                          <FeedbackForm submitFeedback={submitFeedback} smileIndex={smileIndex} />
                        </Paper>
                      </Grid>
                    </Grid>
                  </>
                )}
              </DialogContent>
            </Grid>
          </>
        ) : (
          <>
            {hist.length === 0 ? (
              <NoFeedback
                callback={navigateToExplore}
                hist={hist}
                navigateToExplore={navigateToExplore}
              />
            ) : (
              <>
                <Paper square className={css.ratingBackground}>
                  <FeedbackHeader
                    smileIndex={smileIndex}
                    onSmileyChosen={(index) => setSmileIndex(index)}
                    gradeIndex={gradeIndex}
                    onGradeIndexChosen={(index) => setGradeIndex(index)}
                  />
                </Paper>
                {hist.length > 0 && (
                  <>
                    <Grid className={css.header}>
                      <Typography className={css.typography}>
                        <FormattedMessage id="order_detail" defaultMessage="Order" />
                      </Typography>
                      {location.state.fromPage !== 'trackOrder' && (
                        <Typography
                          className={css.changeTypography}
                          onClick={() =>
                            navigate(`/${context.locale}/order-history`, {
                              state: {
                                fromPage: 'feedback',
                                orderId: location?.state?.orderId
                                  ? location?.state?.orderId
                                  : hist[0]._id,
                              },
                            })
                          }
                        >
                          <FormattedMessage id="feedback_change" defaultMessage="CHANGE" />
                        </Typography>
                      )}
                    </Grid>
                    <Paper className={css.paperOuterArea} square>
                      {location?.state?.orderId && renderTermsList(hist)}
                      {!location?.state?.orderId && (
                        <OrderInfo orderObj={hist[0]} page="feedback" />
                      )}
                    </Paper>
                  </>
                )}

                {/* <Grid className={css.header}>
                  <Typography className={css.typography}>
                    <FormattedMessage id="submit_feedback" defaultMessage="Submit Your Feedback" />
                  </Typography>
                </Grid> */}
                <Paper square className={css.ratingBackground}>
                  <FeedbackForm submitFeedback={submitFeedback} smileIndex={smileIndex} />
                </Paper>
              </>
            )}
          </>
        )}
      </div>
      {isDesktop ? (
        <DialogBox title="" isOpen={stateOpen} onClose={handleClose}>
          {/* <FeedbackInfo onDrawerHandling={changeDrawerStatus} smileIndex={smileIndex} /> */}
          <FeedbackPopup onDrawerHandling={changeDrawerStatus} smileIndex={smileIndex} />
        </DialogBox>
      ) : (
        <DrawerPwa variant="temporary" anchor="bottom" open={stateOpen} onClose={closeDrawer}>
          {/* <FeedbackInfo onDrawerHandling={changeDrawerStatus} smileIndex={smileIndex} /> */}
          <FeedbackPopup onDrawerHandling={changeDrawerStatus} smileIndex={smileIndex} />
        </DrawerPwa>
      )}
      {pageLoader && <Loader />}
      <footer className={css.footer}></footer>
    </Grid>
  );
}

export default Feedback;
